module.exports = __webpack_public_path__ + "static/Baggage-d6bc59bf8cbbcd49615f29196f8f9903.png";